<template>
  <div>
    <div @click="getCenterGps()" id="map" ref="mapArea" v-show="showMap" style="width:100%; height:400px;"></div>
  </div>
</template>

<script>
import markerUser from '../../assets/img/map/ic-marker-user.png'
import markerStore from '../../assets/img/map/ic-marker-store.png'
import { SET_ADDRESS_KAKAO_MAP, SET_LOADING } from '@/store/_actions/actionTypes'
import Bridge from '@/utils/Bridge'

export default {
  name: 'KakaoMap',
  mixins: [Bridge],
  props: {
    isMyLocation: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      appKey: 'e56ddd45af19b6177f392af021ce3247',
      gps: { // 공덕역 롯데캐슬
        latitude: '37.544761',
        longitude: '126.950337'
      },
      map: null,
      userMarker: null,
      storeMarker: null,
      myPostionMarker: null,
      address: '', // 지번 주소
      roadAddress: '', // 도로명 주소
      latLngUser: {},
      latLngStore: {},
      scriptId: 'kakao-map',
      showMap: true,
      init: {
        bounds: null
      }
    }
  },
  computed: {
    userLocation () {
      return this.$store.getters.storeInfo.userLocation
    },
    storeLocation () {
      return this.$store.getters.storeInfo.storeLocation
    },
    centerPosition () {
      // 유저 주소 위경도가 있으면 : 유저 위 경도 객체 반환
      // 유저 주소 위경도가 없고 store 위 경도 있으면 : store 위 경도 객체 반환
      // 둘 다 없으면 false 반환
      return this.userLocation ? this.latLngUser : (this.storeLocation ? (this.latLngStore) : false)
    },
    getDeviceGps () {
      return this.$store.getters.deviceGps
    }
  },
  mounted () {
    this.loadMapScript()
  },
  watch: {
    // SET_DEVICE_GPS 호출 시 실행
    getDeviceGps (newVal) {
      console.log('## kakaoMap getUseDeviceGps')
      if (newVal) {
        const latLng = this.createLatLng(newVal)
        this.map.panTo(latLng)
        this.myPostionMarker.setPosition(latLng)
      }
    },
    // userLocation 변경 시 지도 업데이트
    userLocation: {
      handler (newVal, oldVal) {
        if (!this.isMyLocation) {
          // 위경도가 실제로 변경되었는지 확인
          if (newVal && (!oldVal ||
              newVal.latitude !== oldVal.latitude ||
              newVal.longitude !== oldVal.longitude)) {
            console.log('## kakaoMap userLocation changed', newVal)
            this.updateMapLocation()
          }
        }
      },
      deep: true
    },
    // storeLocation 변경 시 지도 업데이트
    storeLocation: {
      handler (newVal, oldVal) {
        if (!this.isMyLocation) {
          // 위경도가 실제로 변경되었는지 확인
          if (newVal && (!oldVal ||
              newVal.latitude !== oldVal.latitude ||
              newVal.longitude !== oldVal.longitude)) {
            console.log('## kakaoMap storeLocation changed', newVal)
            this.updateMapLocation()
          }
        }
      },
      deep: true
    }
  },

  methods: {
    getCenterGps () {
      const latlng = this.map.getCenter()
      console.log('중심 위도:', latlng.getLat(), '경도:', latlng.getLng())
      // const latLng = this.createLatLng(this.tempGps)
      // this.myPostionMarker.setPosition(latLng)
      // this.map.panTo(latLng)
    },
    // 최대 지도 영역 제한
    limitMapArea () {
      this.init.bounds = this.map.getBounds()
      // 다렌 앞바다 (북서쪽)
      const sw = this.createLatLng({ latitude: 32.73170182008234, longitude: 121.15431226284126 })
      // 도쿠시마 앞바다(남동쪽)
      const ne = this.createLatLng({ latitude: 39.242169322233444, longitude: 133.69026825031926 })

      const limitBounds = new window.kakao.maps.LatLngBounds(sw, ne)

      // 남서쪽 좌표
      const swLatLng = limitBounds.getSouthWest()
      console.log('SW:', swLatLng.getLat(), swLatLng.getLng())

      // 북동쪽 좌표
      const neLatLng = limitBounds.getNorthEast()
      console.log('NE:', neLatLng.getLat(), neLatLng.getLng())
      const map = this.map

      window.kakao.maps.event.addListener(map, 'dragend', () => {
        const center = map.getCenter()
        // 지역 벗어났을 때 초기 위치로 돌아감
        if (!limitBounds.contain(center)) {
          console.log('지도 최대 영역 범위 벗어남 → 원래 위치로 이동')
          this.map.panTo(this.init.bounds)
        }
        // 내 위치 찾기일 때
        if (this.isMyLocation) {
          const latitude = center.getLat()
          const longitude = center.getLng()
          // 배달 주소 변경
          this.getAddressFromCoords(latitude, longitude)
          // 마커가 지도 드래그한 곳의 중앙으로 이동
          this.myPostionMarker.setPosition(center)
        }
      })
    },
    // 초기 지도 로드 메서드
    async loadMapScript () {
      await new Promise((resolve, reject) => {
        let script = document.getElementById(this.scriptId)
        if (script) {
          console.log('## remove kakao script')
          script.parentNode.removeChild(script)
        } else {
          console.log('## load new kakao script')
        }
        script = document.createElement('script')
        script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${this.appKey}&autoload=false&libraries=services`
        script.async = true
        script.id = this.scriptId

        script.onload = () => resolve()
        script.onerror = (err) => {
          console.log(err)
          reject(new Error('Kakao Map SDK load failed'))
        }

        document.head.appendChild(script)
      })

      window.kakao.maps.load(() => {
        if (this.isMyLocation) {
          this.loadMapByMyPosision()
        } else {
          this.loadMapByFranchise()
        }
      })
    },
    // 내 위치로 찾기
    async loadMapByMyPosision (level = 4) {
      const center = this.createLatLng(this.gps)
      const options = {
        center,
        level
      }

      // mapArea가 완전히 렌더링될 때 까지 대기
      await this.$nextTick()
      const container = this.$refs.mapArea

      // 내 위치 찾기 카카오 맵 생성됨
      this.map = new window.kakao.maps.Map(container, options)

      const target = {
        markImage: markerUser,
        position: center
      }
      this.myPostionMarker = this.markTarget(target)
      const latlng = this.map.getCenter()
      this.getAddressFromCoords(latlng.getLat(), latlng.getLng())
      this.limitMapArea()
      this.getGpsByDevice()
    },
    getGpsByDevice () {
      console.log('## loadMapByMyPosision -> getGpsDataByApp')
      // ios 위치정보, 브릿지함수 호출
      if (this.userAgent === 'iOS') {
        // IOS는 js Geolocatio 사용 시 권한이 없을 때 표시되는 Native Toast를 표시할 수 없어 Bridge함수 호출
        this.getGpsDataByApp()
      } else if (this.userAgent === 'android') {
        // AOS는 네이티브 위,경도 받아올 때 앱 심사절차가 까다로워 js Geolocation함수 호출
        this.doGeolocation()
      } else if (this.userAgent === 'mobile') {
        const deviceGps = {
          latitude: '37.544761',
          longitude: '126.950337'
        }
        this.commitGpsAndLoaded(deviceGps)
      }
    },
    // 가맹점 상세 맵 로드
    async loadMapByFranchise () {
      // 1. 유저 좌표가 있으면 유저 좌표 등록를 중심으로(앱)
      // 2. 상점 좌표가 있으면 상점 좌표 등록를 중심으로(웹)
      // 3. 둘 다 없을 경우 맵 로딩 중지 : false
      if (this.storeLocation) this.latLngStore = this.createLatLng(this.storeLocation)
      if (this.userLocation) this.latLngUser = this.createLatLng(this.userLocation)
      const center = this.centerPosition

      if (!center) {
        this.showMap = false
        return
      }
      const options = {
        // 유저, 상점 중 좌표 있는 걸 지도 중심으로 표시
        center,
        level: 4
      }
      // mapArea가 완전히 렌더링될 때 까지 대기
      await this.$nextTick()
      const container = this.$refs.mapArea

      this.map = new window.kakao.maps.Map(container, options)

      if (this.storeLocation) {
        const target = {
          markImage: markerStore,
          position: this.latLngStore
        }
        this.storeMarker = this.markTarget(target)
      }
      if (this.userLocation) {
        const target = {
          markImage: markerUser,
          position: this.latLngUser
        }
        this.userMarker = this.markTarget(target)
      }

      // 유저, 상점 둘다 있을 때만 지도 비율 조정
      this.boundUserBetweenStore()

      this.limitMapArea()
    },
    // 유저, 상점 위치에 맞게 지도 비율 자동 조절
    boundUserBetweenStore () {
      if (this.storeLocation && this.userLocation) {
        const bounds = new window.kakao.maps.LatLngBounds()
        bounds.extend(this.latLngUser)
        bounds.extend(this.latLngStore)
        this.map.setBounds(bounds)
      }
    },
    // 카카오 맵에서 타깃 표시
    markTarget (target) {
      let result = null

      const imageSrc = target.markImage
      const imageSize = new window.kakao.maps.Size(58, 70)
      const imageOption = { offset: new window.kakao.maps.Point(29, 70) } // 가로 절반(29), 세로 끝(70)

      const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize, imageOption)
      result = new window.kakao.maps.Marker({
        map: this.map,
        position: target.position,
        image: markerImage
      })

      return result
    },
    // 현재 주소 정보 가져오기
    getAddressFromCoords (latitude, longitude) {
      const geocoder = new window.kakao.maps.services.Geocoder()

      geocoder.coord2Address(longitude, latitude, (result, status) => {
        if (status === window.kakao.maps.services.Status.OK) {
          const roadAddr = result[0].road_address
          const addr = result[0].address
          const roadAddress = roadAddr ? roadAddr.address_name : ''
          const address = addr ? addr.address_name : ''
          this.$store.commit(SET_ADDRESS_KAKAO_MAP,
            { roadAddress, address }
          )
        }
      })
    },
    doGeolocation () {
      let deviceGps = null
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const latitude = String(pos.coords.latitude)
            const longitude = String(pos.coords.longitude)
            deviceGps = { latitude, longitude }
            this.commitGpsAndLoaded(deviceGps)
          },
          (err) => {
            console.error('오류 발생 :', err)
            // this.toast(this, '디바이스 위치 찾기 권한이 필요합니다.')
            this.$store.commit(SET_LOADING, false)
          },
          {
            enableHighAccuracy: true
          }
        )
      }
    },
    createLatLng (latLng) {
      return new window.kakao.maps.LatLng(latLng.latitude, latLng.longitude)
    },
    // 위경도 변경 시 지도 업데이트
    async updateMapLocation () {
      // 지도가 아직 생성되지 않았으면 생성
      if (!this.map) {
        // 카카오맵 스크립트가 로드되었는지 확인
        if (window.kakao && window.kakao.maps) {
          await this.loadMapByFranchise()
        }
        return
      }

      // 새로운 위경도로 latLng 객체 업데이트
      if (this.storeLocation) {
        this.latLngStore = this.createLatLng(this.storeLocation)
      }
      if (this.userLocation) {
        this.latLngUser = this.createLatLng(this.userLocation)
      }

      const center = this.centerPosition
      if (!center) {
        this.showMap = false
        return
      }

      this.showMap = true

      // 지도 중심 이동
      this.map.panTo(center)

      // 마커 업데이트
      if (this.storeLocation) {
        if (this.storeMarker) {
          this.storeMarker.setPosition(this.latLngStore)
        } else {
          const target = {
            markImage: markerStore,
            position: this.latLngStore
          }
          this.storeMarker = this.markTarget(target)
        }
      }

      if (this.userLocation) {
        if (this.userMarker) {
          this.userMarker.setPosition(this.latLngUser)
        } else {
          const target = {
            markImage: markerUser,
            position: this.latLngUser
          }
          this.userMarker = this.markTarget(target)
        }
      }

      // 유저, 상점 둘다 있을 때만 지도 비율 조정
      this.boundUserBetweenStore()
    }

  }
}
</script>

<style scoped>
#map {
  width: 100%;
  height: 400px;
  /* margin-top: 10px; */
}
select {
  font-size: 16px;
  padding: 4px;
}
</style>
